export default __webpack_public_path__ + "locales/tr/SharingPanel.json?hash=956098a87603a90e1b71a26bf5b7eaaf";